module.exports = {"apiUrl":"https://api.sunfig.com/swa-exp","env":"prod"};